export const beforeAfterData = [
  {
    id: "01",
    title: {
      da: "Vitaran under øjne med cannula",
      en: "Vitaran under eyes with cannula"
    },
    description: {
      da: "Naturlig genskabelse af volumen og glød under øjnene.",
      en: "Natural restoration of volume and glow under the eyes."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/d78e0cc3-43d6-4a5d-b3ce-cba34eb45bc4.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/eadd513b-c9c6-46fe-9ba6-faa1d64695e9.jpg"
  },
  {
    id: "02",
    title: {
      da: "Læbefiller",
      en: "Lip filler"
    },
    description: {
      da: "Smuk volumen og definition af læberne.",
      en: "Beautiful volume and definition of the lips."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/97f8be77-4291-4b4f-adaf-0a3b16af3481.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/0793e0a1-5fa6-422a-a88e-e3c559d3417e.jpg"
  },
  {
    id: "03",
    title: {
      da: "Læbefiller",
      en: "Lip filler"
    },
    description: {
      da: "Smuk volumen og definition af læberne.",
      en: "Beautiful volume and definition of the lips."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/8ed550de-bfa8-49c5-a94e-581d6e7cdad3.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/8eca7605-6059-4d25-a665-e257a50d27f9.jpg"
  },
  {
    id: "04",
    title: {
      da: "Læbefiller",
      en: "Lip filler"
    },
    description: {
      da: "Smuk volumen og definition af læberne.",
      en: "Beautiful volume and definition of the lips."
    },
    before: null,
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/c1c9da50-46a9-4ba0-9dde-e5393f06b365.jpg"
  },
  {
    id: "05",
    title: {
      da: "Læbefiller",
      en: "Lip filler"
    },
    description: {
      da: "Smuk volumen og definition af læberne.",
      en: "Beautiful volume and definition of the lips."
    },
    before: null,
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/ff80c4f7-9ebe-4a47-9dbf-3a2a4ed1aaef.jpg"
  },
  {
    id: "06",
    title: {
      da: "Microneedling",
      en: "Microneedling"
    },
    description: {
      da: "Mekanisk kollagen stimulation.",
      en: "Mechanical collagen stimulation."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/62672926-026f-4b62-9f34-deb507ca2119.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/82366809-3214-49ac-be40-a7960cd3ffe7.jpg",
    hideLabels: true
  },
  {
    id: "07",
    title: {
      da: "Resultat af flere behandlinger over tid i kombination, herunder medicinsk vægttab, botox og filler",
      en: "Result of multiple treatments over time in combination, including medical weight loss, botox, and filler"
    },
    description: {
      da: "Forbedring af hudens elasticitet og struktur over et længere forløb.",
      en: "Improvement of skin elasticity and structure over a longer period."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/eedf77fc-8b9f-4877-b331-b077e3ad579b.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/7600c99d-100b-4ea4-988e-0289f6805b6e.jpg"
  },
  {
    id: "08",
    title: {
      da: "Læbefiller",
      en: "Lip filler"
    },
    description: {
      da: "Smuk volumen og definition af læberne.",
      en: "Beautiful volume and definition of the lips."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/c759d156-6294-437d-985f-4af4d16755e0.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/9afdf2d2-f8f2-4764-b121-b7d449f5bc85.jpg"
  },
  {
    id: "09",
    title: {
      da: "Botox gummy smile (tandkødssmil)",
      en: "Botox gummy smile"
    },
    description: {
      da: "Naturlig og harmonisk fylde.",
      en: "Natural and harmonious fullness."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/36b6ad08-0eec-43f9-9270-c4086c71e4c5.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/06fd6819-901f-4fb8-a84b-745e0704b99d.jpg"
  },
  {
    id: "10",
    title: {
      da: "Læbefiller",
      en: "Lip filler"
    },
    description: {
      da: "Smuk volumen og definition af læberne.",
      en: "Beautiful volume and definition of the lips."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/c32af99d-2170-4353-9591-bb7734f29afd.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/43ba3d50-69b9-4144-9c15-686100cae0ab.jpg"
  },
  {
    id: "11",
    title: {
      da: "Botox i bekymringsrynke",
      en: "Botox in frown lines"
    },
    description: {
      da: "Reduktion af fine linjer og træt hud.",
      en: "Reduction of fine lines and tired skin."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/dd8abecb-088d-4416-8210-df26ed3d416f.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/ac6bf212-6af5-479f-ba23-d4e22948d4a1.jpg"
  },
  {
    id: "12",
    title: {
      da: "Botox Panderynker",
      en: "Forehead Lines Botox"
    },
    description: {
      da: "Glat og ungdommeligt udtryk i panden.",
      en: "Smooth and youthful expression in the forehead."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/baa1adc2-cc52-490e-af6f-99f77fd807e8.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/cb8b125c-ebd0-432a-a809-9386e726ee2f.jpg"
  },
  {
    id: "13",
    title: {
      da: "Botox gummysmile og filler i læber",
      en: "Botox gummy smile and lip filler"
    },
    description: {
      da: "Smukt, naturligt og symmetrisk resultat.",
      en: "Beautiful, natural, and symmetrical result."
    },
    before: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/bf92e554-864b-4018-8453-30eb260f4ac4.jpg",
    after: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/1afaae53-09ac-4d3b-bb4a-e20dadb3740d.jpg"
  }
];
